'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var EmailOpen = function EmailOpen(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 24 24' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: 'currentColor', d: 'M19.94 19.343a.989.989 0 0 0 .06-.341v-8.254a.681.681 0 0 0-.029-.177l-5.657 4.114 5.625 4.658zm-.789.646l-5.671-4.696-1.186.862a.5.5 0 0 1-.588 0l-1.186-.862-5.671 4.696c.048.007.096.011.146.011h14.01c.05 0 .098-.004.146-.01zM4.06 19.344l5.626-4.659-5.657-4.114a.681.681 0 0 0-.029.177v8.254a1 1 0 0 0 .06.342zm15.306-9.57L12 4.25 4.634 9.775 12 15.132l7.366-5.357zM12 3l8.201 6.151c.435.326.799 1.046.799 1.597v8.254A2.001 2.001 0 0 1 19.005 21H4.995A1.996 1.996 0 0 1 3 19.002v-8.254c0-.543.358-1.266.799-1.597L12 3z'
      })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = EmailOpen;